const SELECTOR = '#account_select';

window.$(document).on('change', SELECTOR, (event) => {
  window.$(event.target.form).submit();
});
